import { render, staticRenderFns } from "./FormDoubleSelect.vue?vue&type=template&id=81246e92&"
import script from "./FormDoubleSelect.vue?vue&type=script&lang=js&"
export * from "./FormDoubleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports